import { type FetchLeadsQueryParams } from '@/helpers/fetchLeadsByPropertyReferenceId';
import { type LeadResponse } from '@/store/leads/types/leads-types';
import { captureError } from '@smg-real-estate/browser-rum';

import { get } from './fetch';

const NUMBER_OF_LEADS_PER_PAGE = 20;

export function getRequestPathParameters(params: FetchLeadsQueryParams): string {
  const queryParams = new URLSearchParams();

  if (params.page) {
    queryParams.append('page', params.page.toString());
    queryParams.append('numberOfItemsPerPage', NUMBER_OF_LEADS_PER_PAGE.toString());
  }

  if (params.sortBy) {
    queryParams.append('sortBy', params.sortBy);
  }

  if (params.sortOrder) {
    queryParams.append('sortOrder', params.sortOrder);
  }

  if (params.startDate) {
    queryParams.append('startDate', params.startDate);
  }
  if (params.endDate) {
    queryParams.append('endDate', params.endDate);
  }
  if (params.lang) {
    queryParams.append('lang', params.lang);
  }

  return queryParams.toString();
}

export async function getLeadDataForProperty(
  propertyReferenceId: string,
  params: FetchLeadsQueryParams,
): Promise<LeadResponse> {
  const requestUrl = `${import.meta.env.VUE_UBM_CONTACT_REQUEST_API_URL}/property/${encodeURIComponent(propertyReferenceId)}?${getRequestPathParameters(params)}`;
  try {
    const response = await get(requestUrl);

    return response.json();
  } catch (error) {
    const err = new LeadApiError(requestUrl, error.message);
    captureError(err);
    throw err;
  }
}

export class LeadApiError extends Error {
  endpoint: string;

  constructor(endpoint: string, message: string) {
    super(`Error fetching lead data: ${message}`);

    this.name = 'LeadApiError';
    this.endpoint = endpoint;
  }
}
